import React, { useEffect, useState } from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material UI
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

// MUI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// Helpers

// Components
import { TablePlaceholder } from 'components/TablePlaceholder';
import { LineSkeleton } from 'components/LineSkeleton';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';
import * as UsersActions from 'store/ducks/users/actions';

// Types
import { ApplicationState } from 'store';
import { ScheduleInterface } from 'store/ducks/reports/types';

// Constants
import REPORTS from 'constants/report';

// styles
import useStyles from './Submissions.styles';

interface SubmissionsProps {
  setSubmissionData: (param: any) => void;
  setIsEditSubmissiion: (param: any) => void;
  reportType: string;
  secondReportType?: string;
}

type Props = SubmissionsProps;

const Submissions: React.FC<Props> = ({
  setSubmissionData,
  setIsEditSubmissiion,
  reportType,
  secondReportType,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [tableIsVisible, setTableIsVisible] = useState(false);
  const [schedules, setSchedules] = useState<ScheduleInterface[]>([]);

  const isLoading = useSelector(
    (state: ApplicationState) => state.reports.loading,
  );
  const scheduleList = useSelector(
    (state: ApplicationState) => state.reports.scheduleList,
  );

  const secondScheduleList = useSelector(
    (state: ApplicationState) => state.reports.secondScheduleList,
  );

  const webUsersList = useSelector(
    (state: ApplicationState) => state.users.webUsersList || [],
  );

  const handleLoadTable = () => {
    setTableIsVisible(true);

    // dispatch();
  };

  const getShipping = (schedule: ScheduleInterface) => {
    if (schedule.frequencyType === 0) {
      return schedule.frequencyHour;
    }
    if (schedule.frequencyType === 1) {
      let aux = '';
      schedule.frequencyWeekday.forEach(
        (item: string, i: number) =>
          (aux += `${i ? ', ' : ''}${
            REPORTS.FREQUENCY_WEEK_DAY.find(({ KEY }) => KEY === item)?.VALUE
          }`),
      );
      return aux;
    }
    if (schedule.frequencyType === 2) {
      return `Dia ${schedule.frequencyMonthday}`;
    }
    if (schedule.frequencyType === 3) {
      return `Dia ${schedule.frequencyMonth}`;
    }
  };
  const getFilter = (schedule: ScheduleInterface) => {
    let aux = '';
    Object.keys(schedule.filters).forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };

  const getTimeCourse = (schedule: ScheduleInterface) => {
    const result = Math.ceil(schedule.dataInterval / 86400000);
    return result;
  };

  const getGroupings = (schedule: ScheduleInterface) => {
    let aux = '';
    schedule.groupings.forEach(
      (item: string, i: number) =>
        (aux += `${i ? ', ' : ''}${
          REPORTS.FILTERS_GROUPING.find(({ KEY }) => KEY === item)?.VALUE
        }`),
    );
    return aux;
  };
  const getUsersEmais = (schedule: ScheduleInterface) => {
    if (webUsersList.length && schedule.supervisorIds.length) {
      const feiltersEmails = webUsersList
        .filter((item) => schedule.supervisorIds.some((id) => id === item.id))
        .map(({ email }) => email);

      let aux = '';
      if (feiltersEmails.length > 2) {
        aux = `${feiltersEmails[0]}, ${
          feiltersEmails[1]
        } + ${feiltersEmails.length - 2} outros`;
      } else {
        feiltersEmails.forEach(
          (item: string, i: number) => (aux += `${i ? ', ' : ''}${item}`),
        );
      }

      return aux;
    }
    return '---';
  };

  useEffect(() => {
    dispatch(
      ReportActions.scheduleListRequest({
        reportType,
      }),
    );
  }, []);

  useEffect(() => {
    if (secondReportType) {
      dispatch(
        ReportActions.secondScheduleListRequest({
          reportType: secondReportType,
        }),
      );
    }
  }, []);

  useEffect(() => {
    dispatch(
      UsersActions.listWebUsersRequest({
        body: {
          _includes: 'operators',
          _limit: 9999,
        },
      }),
    );
  }, []);
  useEffect(() => {
    setSchedules([...scheduleList, ...secondScheduleList]);
  }, [scheduleList, secondScheduleList]);

  return (
    <Box>
      {!tableIsVisible && <TablePlaceholder onClick={handleLoadTable} />}

      {tableIsVisible && (
        <TableContainer className={classes.table}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>lote</TableCell>
                <TableCell>Título</TableCell>
                <TableCell>Frequencia</TableCell>
                <TableCell>Envio</TableCell>
                <TableCell>Período</TableCell>
                <TableCell>Filtros</TableCell>
                <TableCell>Agrupamentos</TableCell>
                <TableCell>Destinatários</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!isLoading ? (
                <>
                  {!!schedules.length ? (
                    schedules.map((schedule: ScheduleInterface) => (
                      <TableRow>
                        <TableCell>
                          {schedule?.id && schedule.id.split('-')[0]}
                        </TableCell>
                        <TableCell>{schedule.title}</TableCell>
                        <TableCell>
                          {
                            REPORTS.FREQUENCY_TYPE.find(
                              ({ KEY }) => KEY === schedule.frequencyType,
                            )?.VALUE
                          }
                        </TableCell>
                        <TableCell>{getShipping(schedule)}</TableCell>
                        <TableCell>
                          {getTimeCourse(schedule) > 1
                            ? 'Últimos ' + getTimeCourse(schedule) + ' dias'
                            : 'Último ' + getTimeCourse(schedule) + ' dia'}
                        </TableCell>
                        <TableCell>{getFilter(schedule)}</TableCell>
                        <TableCell>{getGroupings(schedule)}</TableCell>
                        <TableCell>
                          <Box display='flex' alignItems='center'>
                            <Typography>{getUsersEmais(schedule)}</Typography>
                            <IconButton
                              onClick={() => {
                                setSubmissionData(schedule);
                                setIsEditSubmissiion(true);
                              }}>
                              <ArrowForwardIosIcon
                                style={{
                                  color: '#AAB8C2',
                                  width: 8,
                                  height: 8,
                                }}
                              />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell />
                      <TableCell />
                      <TableCell />
                      <TableCell />
                      <TableCell />

                      <TableCell />
                      <TableCell />
                      <TableCell />
                    </TableRow>
                  )}
                </>
              ) : (
                <>
                  <TableRow>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                    <TableCell>
                      <LineSkeleton generateCount={12} />
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export { Submissions };
export default Submissions;
